import ScrutinyPreviewComponent from "./ScrutinyPreviewComponent";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import callApi from "src/services/Common/api";
import { alertMessageState, loadingState } from "src/atom/LoadingState";
import { useRecoilState, useSetRecoilState } from "recoil";
import { getDisplayQuestions } from "src/services/Questionnaire/GetDisplayQuestions";
import { insertScrutinyData } from "src/services/MainPage/GenericService";
import validateMandatoryExpressions from "src/services/Common/ManatoryValidation";
import { useNavigate } from "react-router-dom";

const ScrutinyPreviewPage = ({
  scrutinyId,
  personalData,
  formData,
  masterQuestions,
  candidates = null,
  status,
}) => {
  const [review, setReview] = useState({});
  const [questions, setQuestions] = useState([]);
  const [loader, enableLoader] = useRecoilState(loadingState);
  const [candidateStatus, setCandidateStatus] = useState(
    status ? status : "NOT STARTED"
  );
  const [modalData, setModalData] = useState({ disable: false });
  const [validationErrors, setValidationErrors] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value, type, options } = event.target;
    setReview((prevFormData) => ({
      ...prevFormData,
      [name]:
        type === "select-multiple"
          ? Array.from(options)
              .filter((option) => option.selected)
              .map((option) => option.value)
          : value,
    }));
  };

  useEffect(() => {
    fetchScutinyData();
    setCandidateStatus(status);
  }, [scrutinyId, status]);

  const fetchScutinyData = async () => {
    var fetchQuestionMethod = async () => {
      var url = `/v1/api/scrutiny-questions/${scrutinyId}`;
      const responseData = await callApi(
        url,
        "GET",
        null,
        true,
        setAlertMessage
      );
      if (responseData.success != false) {
        if (responseData.body && Object.keys(responseData.body).length > 0) {
          setQuestions(responseData.body);
          setModalData({
            display: true,
            questions: responseData.body,
            handleInputChange: handleInputChange,
          });
        }
      }
    };
    fetchQuestionMethod();
    var fetchDataMethod = async () => {
      var url = `/v1/api/scrutiny-data/${scrutinyId}`;
      const responseData = await callApi(
        url,
        "GET",
        null,
        true,
        setAlertMessage
      );
      if (responseData.success != false) {
        if (responseData.body && Object.keys(responseData.body).length > 0) {
          setReview(responseData?.body);
        } else {
          setReview({});
        }
      }
    };
    fetchDataMethod();
  };

  const validateForm = (displayQuestions) => {
    const questionsToValidate = questions.filter((item) =>
      displayQuestions.includes(item.id)
    );
    const errors = {};
    let isValid = true;
    questionsToValidate.forEach((question) => {
      var is_valid = validateMandatoryExpressions(question, review);
      if (!is_valid) {
        if (question.type != "F") {
          errors[question.id] = question.mandatoryError
            ? question.mandatoryError
            : `Please provide ${question.label}`;
          isValid = false;
        } else if (!files[question.id]) {
          errors[question.id] = question.mandatoryError
            ? question.mandatoryError
            : `Please provide ${question.label}`;
          isValid = false;
        }
      }
    });
    setValidationErrors(errors);
    return isValid;
  };

  const handleNextButton = () => {
    if (candidates) {
      const currentIndex = candidates.findIndex(
        (candidate) => candidate.id === scrutinyId
      );
      if (currentIndex !== -1 && currentIndex + 1 < candidates.length) {
        const nextCandidateId = candidates[currentIndex + 1].id;
        const status = candidates[currentIndex + 1]?.status;
        navigate("/view-application", {
          state: {
            id: nextCandidateId,
            pageId: 2,
            candidates: candidates,
            status: status,
          },
        });
      } else {
        navigate("/scrutiny");
      }
    } else {
      navigate("/scrutiny");
    }
  };

  const handleSubmit = async () => {
    setValidationErrors({});
    enableLoader(true);
    var display_questions = getDisplayQuestions(questions, review);
    let is_valid = validateForm(display_questions);
    if (is_valid) {
      const formValues = new FormData();
      formValues.append("data", JSON.stringify(review));
      var response = await insertScrutinyData(formValues, scrutinyId);
      if (response?.success) {
        setAlertMessage(`${response.message}|true`);
        setCandidateStatus("VERIFIED");
        fetchScutinyData();
        // setReview({})
      }
    } else {
      enableLoader(false);
    }
    enableLoader(false);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "NOT STARTED":
        return <span className="badge bg-secondary">Not Started</span>;
      case "VERIFIED":
        return <span className="badge bg-success">Verified</span>;
      default:
        return <span className="badge bg-secondary">{status}</span>;
    }
  };

  return (
    <div
      style={{
        width: isSidebarOpen ? "calc(100% - 350px)" : "100%",
        transition: "width 0.3s ease",
      }}
    >
      {isSidebarOpen == false && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "fixed",
            top: "23%",
            right: "40px",
            zIndex: 1000,
          }}
        >
          <button className="btn btn-sm btn-success" onClick={toggleSidebar}>
            Review
          </button>
        </div>
      )}
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        modalData={modalData}
        review={review}
        validationErrors={validationErrors}
      />

      <div className="card">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div>{getStatusBadge(candidateStatus)}</div>
          <div>Submitted Details</div>
        </div>
        <div className="card-body">
          <div className="card mt-2">
            <div
              className="card-header text-white"
              style={{ backgroundColor: "#3C4B64" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <span className="mr-auto">Applicant Details</span>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <tbody>
                    <tr>
                      <th scope="col">Registration Number</th>
                      <td>{personalData?.registrationNo}</td>
                      <th scope="col">Date of Birth</th>
                      <td>{personalData?.dob}</td>
                    </tr>
                    <tr>
                      <th scope="col">Candidate Name</th>
                      <td>{personalData?.applicantName}</td>
                      <th scope="col">Gender</th>
                      <td>{personalData?.gender}</td>
                    </tr>
                    <tr>
                      <th scope="col">Phone Number</th>
                      <td>{personalData?.mobileNumber}</td>
                      <th scope="col">Email</th>
                      <td>{personalData?.email}</td>
                    </tr>
                    <tr>
                      <th scope="col">Father Name</th>
                      <td>{personalData?.fatherName}</td>
                      <th scope="col">Mother Name</th>
                      <td>{personalData?.motherName}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-sm-12">
              <ScrutinyPreviewComponent
                questions={masterQuestions?.personal_details}
                data={formData?.personal_details}
                heading="Personal Details"
              ></ScrutinyPreviewComponent>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-sm-12">
              <ScrutinyPreviewComponent
                questions={masterQuestions?.category_details}
                data={formData?.category_details}
                heading="Category Details"
              ></ScrutinyPreviewComponent>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-sm-12">
              <ScrutinyPreviewComponent
                questions={masterQuestions?.qualification}
                data={formData?.qualification}
                heading="Qualification Details"
              ></ScrutinyPreviewComponent>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <button
          type="button"
          className="btn btn-sm btn-success  me-1"
          onClick={() => handleSubmit()}
          style={{ textDecoration: "none", color: "white" }}
        >
          Submit
        </button>
        <button
          type="button"
          className={
            candidateStatus == "NOT STARTED"
              ? `btn btn-sm btn-secondary me-1`
              : `btn btn-sm btn-primary me-1`
          }
          onClick={handleNextButton}
          style={{ textDecoration: "none" }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ScrutinyPreviewPage;
